import { Module } from "../../Model/Module";

export enum EFetchModuleAction {
  FETCH_MODULES_PENDING = "FETCH_MODULES_PENDING",
  FETCH_MODULES_SUCCESS = "FETCH_MODULES_SUCCESS",
  FETCH_MODULES_ERROR = "FETCH_MODULES_ERROR",
}

export type FetchModuleAction = {
  type: EFetchModuleAction;
  modules?: Module[],
  error?: any;
};

export function fetchModulesPending(): FetchModuleAction {
  return {
    type: EFetchModuleAction.FETCH_MODULES_PENDING,
  };
}

export function fetchModulesSuccess(modules: Module[]): FetchModuleAction {
  return {
    type: EFetchModuleAction.FETCH_MODULES_SUCCESS,
    modules: modules,
  };
}

export function fetchModulesError(error: any): FetchModuleAction {
  return {
    type: EFetchModuleAction.FETCH_MODULES_ERROR,
    error: error,
  };
}
